function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

let t;
let selectedLang;
let collagesCargados = false;
let finalesCargados = false;
let galleryIdActual = null;

// Contador flotante de contenido (solo galería completa)
let contadorHabilitado = false;
let conteoVideos = 0;
let conteoCollages = 0;
let conteoFinales = 0;
let toastTimer = null;
let pestañaGuardada = null; // última pestaña vista, para restaurarla al recargar
let usuarioUid = null;      // uid anónimo estable por dispositivo (para "me gusta")
let authReady = null;       // promesa que resuelve con el uid (o null si falla)
let collagesLightbox = [];  // fotos del collage actual, para el visor a pantalla completa
let eventoMusicaId = null;   // evento activo en la vista de música
let galleryYaCargada = false; // si la galería ya se cargó en esta sesión (para el "volver")
let cancionElegida = null;   // canción seleccionada por el invitado (Parte 2 la guardará)
let audioMusica = null;      // reproductor compartido para los previews
let botonPlayActivo = null;  // botón play de la canción que suena
const MUSIC_TTL_MS = 8 * 60 * 60 * 1000; // 8h de vigencia del código de música en caché
let colaHabilitada = false;   // el evento permite unirse a la fila (colaUsuarios)
let colaConfirmacion = false; // el anfitrión pide confirmación "¿sigues tú?"
let unsubCola = null;         // listener de la fila
let unsubEstado = null;       // listener del estado de la app
let miEntradaId = null;       // id de mi entrada en la fila
let cambiandoCancion = false; // true cuando el invitado está cambiando su canción
let modoModal = 'join';       // 'join' | 'cambio' — qué hace el modal

const LOCKOUT_STAGES = [
    { attempts: 3, duration: 1 * 60 * 1000 },
    { attempts: 4, duration: 5 * 60 * 1000 },
    { attempts: 5, duration: 10 * 60 * 1000 },
    { attempts: 6, duration: 30 * 60 * 1000 },
    { attempts: 7, duration: 60 * 60 * 1000 },
    { attempts: 8, duration: 24 * 60 * 60 * 1000 }
];
let lockoutTimerInterval = null;


if (typeof firebase === 'undefined' || typeof firebase.appCheck === 'undefined' || typeof firebase.storage === 'undefined' || typeof firebase.firestore === 'undefined') {
    console.error("Firebase SDK no se ha cargado correctamente.");
} else {
    console.log("Firebase SDKs cargados correctamente.");

    const firebaseConfig = {
        apiKey: "AIzaSyDqk3Gdb0369KT18-8jjXlpRKDCaM9qPuY",
        authDomain: "spin360app.com",
        projectId: "spin360-videocam",
        storageBucket: "spin360-videocam.firebasestorage.app",
        messagingSenderId: "539452634143",
        appId: "1:539452634143:web:0aa50c76f88c00625c512a",
        measurementId: "G-1JHT3V3PCD"
    };

    try {
        if (!firebase.apps.length) {
            firebase.initializeApp(firebaseConfig);
        } else {
            firebase.app();
        }

        lottie.loadAnimation({
            container: document.getElementById('lottie-animation'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/assets/animations/loader_progress.json'
        });

        const appCheck = firebase.appCheck();
        appCheck.activate('6LfSRi4rAAAAAIvFuoAOO5UCMbzIVfR6Czw4HNdL', true);

        const db = firebase.firestore();
        // Fuerza long-polling (XHR discreto) en vez del streaming WebChannel.
        // Así el token de App Check viaja de forma fiable en cada petición y se
        // evitan los rechazos 401 en Safari / redes con proxy al aplicar App Check.
        db.settings({ experimentalForceLongPolling: true });
        const analytics = firebase.analytics();

        // Autenticación anónima invisible: da un uid ESTABLE por dispositivo (se
        // persiste entre recargas), para que los "me gusta" no cuenten al mismo
        // usuario como varios y no haya pantalla de login que dañe la experiencia.
        // Blindaje: si el SDK de Auth no está cargado (p. ej. HTML cacheado viejo),
        // NO tumbamos la app; solo dejamos los "me gusta" deshabilitados.
        if (typeof firebase.auth === 'function') {
            const auth = firebase.auth();
            authReady = new Promise((resolve) => {
                auth.onAuthStateChanged((user) => {
                    if (user) {
                        usuarioUid = user.uid;
                        resolve(user.uid);
                    } else {
                        auth.signInAnonymously().catch((e) => {
                            console.warn('Auth anónima falló:', e);
                            resolve(null);
                        });
                    }
                });
            });
        } else {
            console.warn('SDK de Auth no disponible; los "me gusta" quedan deshabilitados por ahora.');
            authReady = Promise.resolve(null);
        }


        function cargarVideos(galleryId) {
            const videoList = document.getElementById('video-list');
            videoList.innerHTML = "";

            return db.collection('videogallery').doc(galleryId).collection('videos')
                .orderBy('createdAt', 'desc')
                .get()
                .then((querySnapshot) => {
                    if (querySnapshot.empty) {
                        videoList.innerHTML = `<div class="empty-state"><div class="empty-icon">🎬</div><p>${t.gallery.noVideos}</p></div>`;
                        conteoVideos = 0;
                        actualizarContadorMedia('videos');
                        return;
                    }
                    conteoVideos = querySnapshot.docs.filter(d => {
                        const v = d.data();
                        return v.videoUrl && v.thumbnailUrl && v.createdAt;
                    }).length;
                    actualizarContadorMedia('videos');
                    const promises = querySnapshot.docs.map(doc => {
                        const videoData = doc.data();
                        if (videoData.videoUrl && videoData.thumbnailUrl && videoData.createdAt) {
                            let fileName = 'video.mp4';
                            try {
                                const urlParts = videoData.videoUrl.split('?')[0].split('/');
                                fileName = decodeURIComponent(urlParts[urlParts.length - 1]);
                            } catch (e) { }
                            return crearPlaceholderVideo(fileName, videoData.videoUrl, videoData.thumbnailUrl, videoData.createdAt, {
                                ref: db.collection('videogallery').doc(galleryId).collection('videos').doc(doc.id),
                                reactions: videoData.reactions || {}
                            });
                        }
                        return Promise.resolve();
                    });
                    return Promise.all(promises);
                });
        }

        function cargarCollages(galleryId) {
            const collageList = document.getElementById('collage-list');
            collageList.innerHTML = "";
            collagesLightbox = []; // reinicia la lista del visor para esta galería

            return db.collection('videogallery').doc(galleryId).collection('collage')
                .orderBy('createdAt', 'desc')
                .get()
                .then((querySnapshot) => {
                    if (querySnapshot.empty) {
                        collageList.innerHTML = `<div class="empty-state"><div class="empty-icon">📸</div><p>${t.gallery.noCollages}</p></div>`;
                        conteoCollages = 0;
                        actualizarContadorMedia('collages');
                        return;
                    }

                    conteoCollages = querySnapshot.docs.filter(d => d.data().imageUrl).length;
                    actualizarContadorMedia('collages');
                    querySnapshot.forEach(doc => {
                        const data = doc.data();
                        if (data.imageUrl) {
                            let fileName = 'Collage_Evento.jpg';
                            const urlVisual = data.thumbnailUrl || data.imageUrl;
                            crearPlaceholderCollageGrid(fileName, data.imageUrl, urlVisual, data.createdAt, {
                                ref: db.collection('videogallery').doc(galleryId).collection('collage').doc(doc.id),
                                reactions: data.reactions || {}
                            });
                        }
                    });
                    collagesCargados = true;
                });
        }

        function cargarFinales(galleryId) {
            const finalList = document.getElementById('final-list');
            finalList.innerHTML = "";

            // Buscamos en la subcolección videoFinal donde el status sea completed
            return db.collection('videogallery').doc(galleryId).collection('videoFinal')
                .where('status', '==', 'completed')
                .orderBy('createdAt', 'desc')
                .get()
                .then((querySnapshot) => {
                    if (querySnapshot.empty) {
                        finalList.innerHTML = `<div class="empty-state"><div class="empty-icon">🎬</div><p>${t.gallery.noFinals}</p></div>`;
                        conteoFinales = 0;
                        actualizarContadorMedia('finales');
                        return;
                    }
                    conteoFinales = querySnapshot.docs.filter(d => {
                        const v = d.data();
                        return v.videoUrl && v.thumbnailUrl && v.createdAt;
                    }).length;
                    actualizarContadorMedia('finales');
                    const promises = querySnapshot.docs.map((doc, index) => {
                        const data = doc.data();
                        if (data.videoUrl && data.thumbnailUrl && data.createdAt) {
                            // Le asignamos un nombre bonito por defecto para la descarga
                            let fileName = `Video_Especial_${index + 1}.mp4`;
                            return crearPlaceholderVideoFinal(fileName, data.videoUrl, data.thumbnailUrl, data.createdAt);
                        }
                        return Promise.resolve();
                    });
                    return Promise.all(promises).then(() => { finalesCargados = true; });
                });
        }

        function crearPlaceholderVideoFinal(nombre, videoUrl, thumbnailUrl, createdAt) {
            return new Promise((resolve) => {
                const finalList = document.getElementById('final-list'); // Apunta a la nueva lista

                const videoPlaceholderContainer = document.createElement('div');
                const thumbnailImg = document.createElement('img');
                thumbnailImg.alt = t.media.thumbnailAlt(nombre);
                thumbnailImg.className = 'video-thumbnail-img';

                thumbnailImg.onload = () => {
                    videoPlaceholderContainer.className = 'video-container video-placeholder';
                    videoPlaceholderContainer.style.cursor = 'pointer';

                    const playIcon = document.createElement('div');
                    playIcon.className = 'play-icon-overlay';
                    playIcon.innerHTML = '▶';

                    videoPlaceholderContainer.appendChild(thumbnailImg);
                    videoPlaceholderContainer.appendChild(playIcon);

                    renderizarBotones(videoPlaceholderContainer, nombre, videoUrl, 'video/mp4');
                    renderizarVigencia(videoPlaceholderContainer, createdAt);

                    videoPlaceholderContainer.addEventListener('click', () => {
                        // Reutilizamos tu excelente función inyectarYReproducirVideo
                        inyectarYReproducirVideo(videoPlaceholderContainer, nombre, videoUrl, thumbnailUrl, createdAt);
                    }, { once: true });

                    finalList.appendChild(videoPlaceholderContainer);
                    resolve(true);
                };

                thumbnailImg.onerror = () => resolve(false);
                thumbnailImg.src = thumbnailUrl;
            });
        }

        function crearPlaceholderCollageGrid(nombre, urlOriginal, urlVisual, createdAt, likeCtx) {
            const collageList = document.getElementById('collage-list');

            const container = document.createElement('div');
            container.className = 'video-container collage-grid-item';
            container.style.cursor = 'default';

            // 1. Elemento SHIMMER
            const shimmer = document.createElement('div');
            shimmer.className = 'shimmer-box';
            container.appendChild(shimmer);

            // 2. Elemento IMAGEN
            const img = document.createElement('img');
            img.className = "collage-img";
            img.alt = t.media.photoAlt;

            img.onload = () => {
                shimmer.remove(); // Quitar brillo
                img.classList.add('loaded'); // Mostrar imagen
            };

            img.onerror = () => {
                shimmer.remove(); // Si falla, quitamos el shimmer para no engañar al usuario
                console.error("Error cargando miniatura:", urlVisual);
            };

            // Asignar atributos y carga
            img.loading = "lazy";
            img.decoding = "async";
            img.src = urlVisual; // El navegador empieza a descargar aquí

            container.appendChild(img);

            // Lightbox: al tocar la foto se abre a pantalla completa (zoom / swipe)
            const indiceLightbox = collagesLightbox.length;
            collagesLightbox.push({ src: urlOriginal, imgEl: img });
            img.style.cursor = 'zoom-in';
            img.addEventListener('click', (e) => {
                e.stopPropagation();
                abrirLightboxCollages(indiceLightbox);
            });

            // Botones y Vigencia
            const mimeType = urlOriginal.toLowerCase().includes('.png') ? 'image/png' : 'image/jpeg';
            renderizarBotones(container, nombre, urlOriginal, mimeType);
            renderizarVigencia(container, createdAt);
            agregarReacciones(container, likeCtx);


            collageList.appendChild(container);
        }

        async function iniciarCargaGaleria(galleryId) {
            const loader = document.getElementById('loader');
            galleryIdActual = galleryId;
            collagesCargados = false;
            finalesCargados = false;
            contadorHabilitado = true; // el contador flotante solo aplica a la galería

            // Recuperar la última pestaña vista ANTES de que cambiarPestaña la sobrescriba
            try { pestañaGuardada = localStorage.getItem('lastTab_' + galleryId); } catch (e) { pestañaGuardada = null; }

            window.cambiarPestaña('videos');

            try {
                const eventDocRef = db.collection('videogallery').doc(galleryId);
                const eventDoc = await eventDocRef.get();
                if (!eventDoc.exists) {
                    document.body.innerHTML = `<div style="text-align: center; padding: 50px;"><h1>${t.gallery.notFoundTitle}</h1><p>${t.gallery.notFoundText}</p></div>`;
                    if (loader) loader.style.display = 'none';
                    return;
                }

                const eventData = eventDoc.data();

                // Botón de música flotante (solo si el evento lo habilita)
                if (eventData.musicaUser === true) {
                    const btnMusica = document.getElementById('music-button');
                    if (btnMusica) btnMusica.classList.add('visible');
                }
                colaHabilitada = eventData.colaUsuarios === true;
                colaConfirmacion = eventData.colaConfirmacion === true;

                await actualizarLogoSiExiste(eventData);
                const nombreEventoEl = document.getElementById('nombre-evento');

                let nombreDelEventoEncontrado = false;

                if (eventData.nombre) {
                    nombreEventoEl.textContent = eventData.nombre;
                    nombreEventoEl.style.opacity = 1;
                    nombreEventoEl.style.display = "block";
                    nombreDelEventoEncontrado = true;
                } else {
                    nombreEventoEl.textContent = t.gallery.defaultTitle;
                }

                if (eventData.empresa || eventData.instagram || eventData.whatsapp) {
                    const directHeaderData = {
                        empresa: eventData.empresa,
                        instagram: eventData.instagram,
                        whatsapp: eventData.whatsapp
                    };
                    actualizarHeaderConJsonData(directHeaderData);

                } else {
                    const jsonDoc = await eventDocRef.collection('empresaJSON').doc('1').get();
                    if (jsonDoc.exists) {
                        const empresaJsonData = jsonDoc.data();

                        if (!nombreDelEventoEncontrado && empresaJsonData.nombreEvento) {
                            nombreEventoEl.textContent = empresaJsonData.nombreEvento;
                            nombreEventoEl.style.opacity = 1;
                            nombreEventoEl.style.display = "block";
                            nombreDelEventoEncontrado = true;
                        }

                        if (empresaJsonData.jsonUrl) {
                            try {
                                const response = await fetch(empresaJsonData.jsonUrl);
                                const jsonData = await response.json();
                                actualizarHeaderConJsonData(jsonData);
                            } catch (fetchError) {
                                console.warn("No se pudo cargar el JSON del header:", fetchError);
                                actualizarHeaderConJsonData(null);
                            }
                        } else {
                            actualizarHeaderConJsonData(null);
                        }
                    } else {
                        actualizarHeaderConJsonData(null);
                    }
                }

                if (!nombreDelEventoEncontrado) {
                    nombreEventoEl.textContent = t.gallery.defaultTitle;
                }

                const selector = document.getElementById('media-selector');
                if (selector) selector.classList.remove('hidden');

                if (eventData && eventData.tieneClave === true) {
                    const fechaActualizacion = eventData.fechaActualizacion || null;
                    await manejarFlujoConClave(galleryId, fechaActualizacion);
                } else {
                    localStorage.removeItem(`auth_${galleryId}`);
                    await cargarContenidoGaleria(galleryId);
                }
            } catch (error) {
                console.error("Error fatal al iniciar la carga de la galería:", error);
                document.getElementById('video-list').innerHTML = `<p>${t.gallery.loadError}</p>`;
                if (loader) loader.style.display = 'none';
            }
        }

        function crearPlaceholderVideo(nombre, videoUrl, thumbnailUrl, createdAt, likeCtx) {
            return new Promise((resolve) => {
                const videoList = document.getElementById('video-list');

                const videoPlaceholderContainer = document.createElement('div');
                const thumbnailImg = document.createElement('img');
                thumbnailImg.alt = t.media.thumbnailAlt(nombre);
                thumbnailImg.className = 'video-thumbnail-img';

                thumbnailImg.onload = () => {
                    videoPlaceholderContainer.className = 'video-container video-placeholder';
                    videoPlaceholderContainer.style.cursor = 'pointer';

                    const playIcon = document.createElement('div');
                    playIcon.className = 'play-icon-overlay';
                    playIcon.innerHTML = '▶';

                    videoPlaceholderContainer.appendChild(thumbnailImg);
                    videoPlaceholderContainer.appendChild(playIcon);

                    renderizarBotones(videoPlaceholderContainer, nombre, videoUrl, 'video/mp4');
                    renderizarVigencia(videoPlaceholderContainer, createdAt);
                    agregarReacciones(videoPlaceholderContainer, likeCtx);

                    videoPlaceholderContainer.addEventListener('click', () => {
                        inyectarYReproducirVideo(videoPlaceholderContainer, nombre, videoUrl, thumbnailUrl, createdAt);
                    }, { once: true });

                    videoList.appendChild(videoPlaceholderContainer);
                    resolve(true);
                };

                thumbnailImg.onerror = () => {
                    resolve(false);
                };

                thumbnailImg.src = thumbnailUrl;
            });
        }


        function inyectarYReproducirVideo(container, nombre, videoUrl, thumbnailUrl, createdAt) {
            container.classList.add('loading');

            const lottieContainer = document.createElement('div');
            lottieContainer.className = 'lottie-video-loader';
            container.appendChild(lottieContainer);

            // 2. Cargamos la animación de Lottie en este contenedor específico
            const animation = lottie.loadAnimation({
                container: lottieContainer,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: '/assets/animations/loader_video.json'
            });

            const video = document.createElement('video');
            video.controls = true;
            video.src = videoUrl;
            video.poster = thumbnailUrl;
            video.preload = 'auto';
            video.autoplay = true;
            video.playsInline = true;
            video.crossOrigin = "anonymous";

            video.onloadeddata = () => {
                animation.destroy();

                const mediaToRemove = container.querySelectorAll('img, .play-icon-overlay, .lottie-video-loader');
                mediaToRemove.forEach(el => el.remove());

                container.classList.remove('video-placeholder', 'loading');
                container.classList.add('video-container');
                container.style.cursor = 'default';

                container.prepend(video);

                if (!container.querySelector('.actions-container')) {
                    renderizarBotones(container, nombre, videoUrl, 'video/mp4');
                    renderizarVigencia(container, createdAt);
                }

                video.play().catch(() => { });
            };

            video.addEventListener('play', () => {
                const allVideos = document.querySelectorAll('#video-list video');
                allVideos.forEach(otherVideo => {
                    if (otherVideo !== video && !otherVideo.paused) {
                        otherVideo.pause();
                    }
                });
            });

            video.onerror = () => {
                animation.destroy();
                lottieContainer.remove();
                container.classList.remove('loading');
                mostrarToast(t.media.videoLoadError);
            };

        }

        function descargarConProgreso(url, onProgress) {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';

                xhr.onprogress = function (event) {
                    if (event.lengthComputable) {
                        const percentComplete = Math.round((event.loaded / event.total) * 100);
                        onProgress(percentComplete);
                    } else {
                        onProgress(null);
                    }
                };

                xhr.onload = function () {
                    if (this.status === 200) {
                        resolve(this.response);
                    } else {
                        reject(new Error("Error HTTP al descargar: " + this.status));
                    }
                };

                xhr.onerror = function () {
                    reject(new Error("Error de red."));
                };

                xhr.send();
            });
        }

        function inyectarCollage(container, nombre, imageUrl, createdAt) {
            container.innerHTML = '';
            container.style.cursor = 'default';
            container.classList.remove('video-placeholder');
            container.classList.add('video-container');

            const img = document.createElement('img');
            img.src = imageUrl;
            img.className = 'collage-img';
            img.alt = nombre;

            container.appendChild(img);

            const actionsContainer = document.createElement('div');
            actionsContainer.className = 'actions-container';

            const mimeType = imageUrl.toLowerCase().includes('.png') ? 'image/png' : 'image/jpeg';
            renderizarBotones(container, nombre, imageUrl, mimeType);
            renderizarVigencia(container, createdAt);

        }



        function cargarVideoIndividual(videoId) {
            const videoList = document.getElementById('video-list');
            videoList.innerHTML = "";
            videoList.classList.remove('hidden');

            return db.collection('publicvideos').doc(videoId).get()
                .then(doc => {
                    if (doc.exists) {
                        const videoData = doc.data();
                        actualizarLogoSiExiste(videoData).then(() => {
                            mostrarLogo();
                        });
                        const nombreEventoEl = document.getElementById('nombre-evento');
                        if (videoData.nombreEvento) {
                            nombreEventoEl.textContent = videoData.nombreEvento;
                            nombreEventoEl.style.opacity = 1;
                            nombreEventoEl.style.display = "block";
                        } else {
                            nombreEventoEl.style.display = "none";
                        }

                        if (videoData.empresa || videoData.instagram || videoData.whatsapp) {

                            const directHeaderData = {
                                empresa: videoData.empresa,
                                instagram: videoData.instagram,
                                whatsapp: videoData.whatsapp
                            };
                            actualizarHeaderConJsonData(directHeaderData);

                        } else if (videoData.jsonUrl) {

                            fetch(videoData.jsonUrl)
                                .then(response => response.json())
                                .then(jsonData => actualizarHeaderConJsonData(jsonData))
                                .catch(err => {
                                    console.error("Error al cargar JSON para video individual:", err);
                                    actualizarHeaderConJsonData(null);
                                });
                        } else {
                            actualizarHeaderConJsonData(null);
                        }
                        crearPlaceholderVideo(
                            `video_${videoId}.mp4`,
                            videoData.videoUrl,
                            videoData.thumbnailUrl,
                            videoData.createdAt
                        );

                    } else {
                        videoList.innerHTML = `<p>${t.individual.videoNotFound}</p>`;
                    }
                });
        }

        function cargarCollageIndividual(collageId) {
            const videoList = document.getElementById('video-list');
            videoList.innerHTML = "";
            videoList.classList.remove('hidden');

            return db.collection('publiccollages').doc(collageId).get()
                .then(doc => {
                    if (doc.exists) {
                        const collageData = doc.data();

                        actualizarLogoSiExiste(collageData).then(() => {
                            mostrarLogo();
                        });
                        const nombreEventoEl = document.getElementById('nombre-evento');

                        if (collageData.nombreEvento) {
                            nombreEventoEl.textContent = collageData.nombreEvento;
                            nombreEventoEl.style.opacity = 1;
                            nombreEventoEl.style.display = "block";
                        } else {
                            nombreEventoEl.style.display = "none";
                        }

                        if (collageData.empresa || collageData.instagram || collageData.whatsapp) {
                            const directHeaderData = {
                                empresa: collageData.empresa,
                                instagram: collageData.instagram,
                                whatsapp: collageData.whatsapp
                            };
                            actualizarHeaderConJsonData(directHeaderData);
                        } else if (collageData.jsonUrl) {
                            fetch(collageData.jsonUrl)
                                .then(response => response.json())
                                .then(jsonData => actualizarHeaderConJsonData(jsonData))
                                .catch(err => {
                                    console.error("Error al cargar JSON para collage:", err);
                                    actualizarHeaderConJsonData(null);
                                });
                        } else {
                            actualizarHeaderConJsonData(null);
                        }

                        const urlFinal = collageData.imageUrl;
                        const urlVisual = collageData.thumbnailUrl || collageData.imageUrl;


                        const container = document.createElement('div');
                        container.className = 'video-container collage-grid-item';
                        container.style.cursor = 'default';

                        const shimmer = document.createElement('div');
                        shimmer.className = 'shimmer-box';
                        container.appendChild(shimmer);

                        const img = document.createElement('img');
                        img.className = "collage-img";
                        img.alt = t.media.photoAlt;

                        img.onload = () => {
                            shimmer.remove();
                            img.classList.add('loaded');
                        };

                        img.onerror = () => {
                            shimmer.remove();
                            console.error("Error cargando imagen del collage");
                        };

                        img.src = urlVisual;
                        container.appendChild(img);

                        // Lightbox de una sola foto (vista individual /collage/xxx, sin swipe)
                        collagesLightbox = [{ src: urlFinal, imgEl: img }];
                        img.style.cursor = 'zoom-in';
                        img.addEventListener('click', (e) => {
                            e.stopPropagation();
                            abrirLightboxCollages(0);
                        });

                        const mimeType = urlFinal.toLowerCase().includes('.png') ? 'image/png' : 'image/jpeg';
                        renderizarBotones(container, `collage_${collageId}.jpg`, urlFinal, mimeType);
                        renderizarVigencia(container, collageData.createdAt);

                        videoList.appendChild(container);

                    } else {
                        videoList.innerHTML = `<p>${t.individual.collageNotFound}</p>`;
                    }
                });
        }

        function actualizarHeaderConJsonData(jsonData) {
            if (!jsonData) return;

            const videoCountEl = document.getElementById('video-count');
            const instagramLink = document.getElementById('instagram-link');
            const whatsappButton = document.getElementById('whatsapp-button');

            const showElement = (element, displayType = 'block') => {
                if (element) {
                    element.style.display = displayType;

                    setTimeout(() => {
                        if (element.id === 'instagram-link') {
                            const icon = element.querySelector('.instagram-icon');
                            if (icon) icon.style.opacity = 1;
                        } else {
                            element.style.opacity = 1;
                        }
                    }, 10);
                }
            };

            if (jsonData.empresa) {
                videoCountEl.textContent = `- ${jsonData.empresa} -`;
                showElement(videoCountEl, 'block');
            } else {
                videoCountEl.style.display = "none";
            }

            if (jsonData.instagram) {
                instagramLink.href = jsonData.instagram.startsWith('http') ? jsonData.instagram : `https://instagram.com/${jsonData.instagram}`;
                showElement(instagramLink, 'block');
            } else {
                instagramLink.style.display = "none";
            }

            if (jsonData.whatsapp) {
                const whatsappNumber = jsonData.whatsapp.replace(/\D/g, '');
                const message = encodeURIComponent(t.share.whatsappMessage);
                whatsappButton.href = `https://wa.me/${whatsappNumber}?text=${message}`;
                showElement(whatsappButton, 'flex');
                whatsappButton.classList.add('attention');
                mostrarWhatsappCta();
            } else {
                whatsappButton.style.display = "none";
                whatsappButton.classList.remove('attention');
                ocultarWhatsappCta();
            }
        }

        async function cargarContenidoGaleria(galleryId) {
            const videoListContainer = document.getElementById('video-list');
            const loader = document.getElementById('loader');

            videoListContainer.classList.remove('hidden');
            if (loader) loader.style.display = 'flex';

            try {
                await cargarVideos(galleryId);
            } catch (error) {
                console.error("Fallo la carga de videos:", error);
            } finally {
                if (loader) loader.style.display = 'none';
                mostrarLogo();
                mostrarFooter();
                galleryYaCargada = true;
            }

            // Restaurar la última pestaña que el usuario tenía abierta (solo galería)
            if (pestañaGuardada === 'collages' || pestañaGuardada === 'finales') {
                window.cambiarPestaña(pestañaGuardada);
            }
            pestañaGuardada = null;
        }

        function manejarFlujoConClave(galleryId, fechaActualizacionFirestore) {
            const authKey = `auth_${galleryId}`;
            const sessionData = JSON.parse(localStorage.getItem(authKey));

            const timestampFirestore = fechaActualizacionFirestore ? fechaActualizacionFirestore.toMillis() : 0;

            if (sessionData && sessionData.authenticated) {
                if (timestampFirestore === 0 || timestampFirestore <= sessionData.timestamp) {
                    console.log("Sesión válida y actualizada. Cargando contenido.");
                    return cargarContenidoGaleria(galleryId);
                } else {
                    console.log("La contraseña del evento ha cambiado. Se requiere nueva autenticación.");
                    localStorage.removeItem(authKey);
                }
            }

            mostrarFormularioClave(galleryId, fechaActualizacionFirestore);
        }

        function mostrarFormularioClave(galleryId, fechaActualizacionFirestore) {
            const promptContainer = document.getElementById('password-prompt-container');
            const videoList = document.getElementById('video-list');
            const loader = document.getElementById('loader');
            const submitBtn = document.getElementById('password-submit-btn');

            videoList.classList.add('hidden');
            promptContainer.classList.remove('hidden');
            if (loader) loader.style.display = 'none';
            mostrarLogo();
            mostrarFooter();

            if (verificarYActualizarBloqueo(galleryId)) {
                return;
            }

            // Enviar con el botón (type="submit") o con la tecla Enter
            const passwordForm = document.getElementById('password-form');
            if (passwordForm) {
                passwordForm.onsubmit = (e) => {
                    e.preventDefault();
                    manejarEnvioClave(galleryId, fechaActualizacionFirestore);
                };
            }
        }

        async function manejarEnvioClave(galleryId, fechaActualizacionFirestore) {
            if (verificarYActualizarBloqueo(galleryId)) {
                return;
            }

            const passwordInput = document.getElementById('password-input');
            const password = passwordInput.value;
            const submitBtn = document.getElementById('password-submit-btn');
            const errorMsg = document.getElementById('password-error-message');

            if (!password) {
                errorMsg.textContent = t.password.enterPassword;
                return;
            }

            submitBtn.disabled = true;
            submitBtn.textContent = t.password.verifying;
            errorMsg.textContent = '';

            try {
                const response = await fetch('https://us-central1-spin360-videocam.cloudfunctions.net/verifyClaveEvento', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ cardID: galleryId, password: password })
                });

                const result = await response.json();

                if (response.ok) {
                    const sessionData = {
                        authenticated: true,
                        timestamp: fechaActualizacionFirestore ? fechaActualizacionFirestore.toMillis() : Date.now()
                    };
                    localStorage.setItem(`auth_${galleryId}`, JSON.stringify(sessionData));
                    localStorage.removeItem(`lockout_${galleryId}`);
                    document.getElementById('password-prompt-container').classList.add('hidden');
                    await cargarContenidoGaleria(galleryId);
                } else {
                    errorMsg.textContent = result.error || t.password.genericError;
                    manejarIntentoFallido(galleryId);
                }
            } catch (error) {
                console.error("Error de conexión al verificar la contraseña:", error);
                errorMsg.textContent = t.password.connectionError;
            } finally {
                submitBtn.disabled = false;
                submitBtn.textContent = t.password.enter;
                passwordInput.value = '';
            }
        }

        function manejarIntentoFallido(galleryId) {
            const key = `lockout_${galleryId}`;
            let data = JSON.parse(localStorage.getItem(key)) || { attempts: 0 };
            data.attempts += 1;

            const stage = LOCKOUT_STAGES.find(s => s.attempts === data.attempts);
            if (stage) {
                data.lockUntil = Date.now() + stage.duration;
            } else if (data.attempts > LOCKOUT_STAGES[LOCKOUT_STAGES.length - 1].attempts) {
                data.lockUntil = Date.now() + LOCKOUT_STAGES[LOCKOUT_STAGES.length - 1].duration;
            }

            localStorage.setItem(key, JSON.stringify(data));
            verificarYActualizarBloqueo(galleryId);
        }

        function verificarYActualizarBloqueo(galleryId) {
            const key = `lockout_${galleryId}`;
            const data = JSON.parse(localStorage.getItem(key));
            const submitBtn = document.getElementById('password-submit-btn');
            const errorMsg = document.getElementById('password-error-message');

            if (lockoutTimerInterval) {
                clearInterval(lockoutTimerInterval);
                lockoutTimerInterval = null;
            }

            if (data && data.lockUntil && data.lockUntil > Date.now()) {
                submitBtn.disabled = true;

                const updateTimer = () => {
                    const timeLeft = Math.ceil((data.lockUntil - Date.now()) / 1000);
                    if (timeLeft <= 0) {
                        clearInterval(lockoutTimerInterval);
                        errorMsg.textContent = t.password.tryAgain;
                        submitBtn.disabled = false;
                        localStorage.removeItem(key);
                    } else {
                        const minutes = Math.floor(timeLeft / 60);
                        const seconds = timeLeft % 60;
                        errorMsg.textContent = t.password.tooManyAttempts(minutes, seconds);
                    }
                };

                updateTimer();
                lockoutTimerInterval = setInterval(updateTimer, 1000);
                return true; // Está bloqueado
            }

            submitBtn.disabled = false;
            return false; // No está bloqueado
        }

        function renderizarBotones(container, nombre, url, tipoMime) {
            const actionsContainer = document.createElement('div');
            actionsContainer.className = 'actions-container';

            actionsContainer.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            if (isIOS() && navigator.share) {

                let archivoGuardadoEnMemoria = null;

                const shareDownloadButton = document.createElement('button');
                shareDownloadButton.className = 'action-button download-button';
                shareDownloadButton.innerHTML = `🔗 <span class="button-text">${t.global.shareAndDownload}</span>`;

                shareDownloadButton.addEventListener('click', async (e) => {
                    e.stopPropagation();

                    if (archivoGuardadoEnMemoria) {
                        try {
                            await navigator.share({
                                files: [archivoGuardadoEnMemoria],
                                title: t.share.title,
                                text: t.share.text,
                            });
                        } catch (err) {
                            console.log("El usuario cerró el menú de compartir.");
                        }
                        return; // Detenemos la función aquí
                    }

                    const globalLoader = document.getElementById('loader');
                    const lottieAnim = document.getElementById('lottie-animation');

                    globalLoader.style.display = 'flex';
                    globalLoader.style.flexDirection = 'column';
                    shareDownloadButton.disabled = true;

                    if (lottieAnim) lottieAnim.style.display = 'none';

                    let progressText = document.getElementById('download-progress-text');
                    if (!progressText) {
                        progressText = document.createElement('div');
                        progressText.id = 'download-progress-text';
                        progressText.style.cssText = "color: white; font-size: 24px; font-weight: bold; font-family: Arial, sans-serif; text-align: center;";
                        globalLoader.appendChild(progressText);
                    }
                    progressText.style.display = 'block';
                    progressText.textContent = t.progress.preparingZero;

                    try {
                        const blob = await descargarConProgreso(url, (porcentaje) => {
                            if (porcentaje !== null) {
                                progressText.textContent = t.progress.downloading(porcentaje);
                            } else {
                                progressText.textContent = t.progress.downloadingVideo;
                            }
                        });

                        progressText.textContent = t.progress.ready;

                        archivoGuardadoEnMemoria = new File([blob], nombre, { type: tipoMime });

                        const shareData = {
                            files: [archivoGuardadoEnMemoria],
                            title: t.share.title,
                            text: t.share.text,
                        };

                        if (navigator.canShare && navigator.canShare(shareData)) {
                            await navigator.share(shareData);
                        } else {
                            throw new Error("No se pudo compartir.");
                        }

                    } catch (error) {
                        if (error.name !== 'AbortError') {
                            console.log('Apple bloqueó el menú por tiempo de descarga largo.');

                            shareDownloadButton.innerHTML = `✅ <span class="button-text">${t.progress.readyShareTap}</span>`;
                            shareDownloadButton.style.backgroundColor = "#28a745"; // Lo pintamos de verde éxito

                            setTimeout(() => {
                                mostrarToast(t.share.videoDownloadedAlert, 6500);
                            }, 300);
                        }
                    } finally {
                        globalLoader.style.display = 'none';
                        globalLoader.style.flexDirection = 'row';
                        if (progressText) progressText.style.display = 'none';
                        if (lottieAnim) lottieAnim.style.display = 'block';
                        shareDownloadButton.disabled = false;
                    }
                });
                actionsContainer.appendChild(shareDownloadButton);

            } else {
                let archivoGuardadoEnMemoria = null;

                const downloadButton = document.createElement('button'); // Cambiado de <a> a <button>
                downloadButton.className = 'action-button download-button';
                downloadButton.innerHTML = `📥 <span class="button-text">${t.global.download}</span>`;

                downloadButton.addEventListener('click', async (e) => {
                    e.stopPropagation();
                    if (downloadButton.disabled) return;

                    const textoOriginal = downloadButton.innerHTML;
                    downloadButton.disabled = true;

                    try {
                        let blob;
                        if (archivoGuardadoEnMemoria) {
                            blob = archivoGuardadoEnMemoria;
                            downloadButton.innerHTML = `⏳ <span class="button-text">${t.progress.preparing}</span>`;
                        } else {
                            blob = await descargarConProgreso(url, (porcentaje) => {
                                if (porcentaje !== null) {
                                    downloadButton.innerHTML = `⏳ <span class="button-text">${t.progress.downloadingShort(porcentaje)}</span>`;
                                } else {
                                    downloadButton.innerHTML = `⏳ <span class="button-text">${t.progress.downloadingNoPct}</span>`;
                                }
                            });
                            archivoGuardadoEnMemoria = blob; // Guardamos en memoria
                        }

                        downloadButton.innerHTML = `✅ <span class="button-text">${t.progress.saved}</span>`;
                        downloadButton.style.backgroundColor = "#28a745";

                        const blobUrl = window.URL.createObjectURL(blob);
                        const tempLink = document.createElement('a');
                        tempLink.href = blobUrl;
                        tempLink.download = nombre;
                        document.body.appendChild(tempLink);
                        tempLink.click();
                        document.body.removeChild(tempLink);

                        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 2000);

                    } catch (error) {
                        console.error("Error al descargar:", error);
                        window.open(url, '_blank');
                    } finally {
                        setTimeout(() => {
                            downloadButton.innerHTML = textoOriginal;
                            downloadButton.style.backgroundColor = "";
                            downloadButton.disabled = false;
                        }, 3000);
                    }
                });
                actionsContainer.appendChild(downloadButton);

                if (navigator.share && navigator.canShare) {
                    const shareButton = document.createElement('button');
                    shareButton.className = 'action-button share-button';
                    shareButton.innerHTML = `🔗 <span class="button-text">${t.global.share}</span>`;

                    shareButton.addEventListener('click', async (e) => {
                        e.stopPropagation();
                        if (shareButton.disabled) return;

                        const textoOriginal = shareButton.innerHTML;
                        shareButton.disabled = true;

                        try {
                            let blob;
                            if (archivoGuardadoEnMemoria) {
                                blob = archivoGuardadoEnMemoria;
                                shareButton.innerHTML = `⏳ <span class="button-text">${t.progress.preparing}</span>`;
                            } else {
                                blob = await descargarConProgreso(url, (porcentaje) => {
                                    if (porcentaje !== null) {
                                        shareButton.innerHTML = `⏳ <span class="button-text">${t.progress.preparingPct(porcentaje)}</span>`;
                                    } else {
                                        shareButton.innerHTML = `⏳ <span class="button-text">${t.progress.preparing}</span>`;
                                    }
                                });
                                archivoGuardadoEnMemoria = blob;
                            }

                            shareButton.innerHTML = `✅ <span class="button-text">${t.progress.readyShort}</span>`;

                            const file = new File([blob], nombre, { type: tipoMime });
                            const shareData = {
                                files: [file],
                                title: t.share.title,
                                text: t.share.text,
                            };

                            if (navigator.canShare(shareData)) {
                                await navigator.share(shareData);
                            }
                        } catch (error) {
                            console.error('Error share Android:', error);
                            if (error.name !== 'AbortError') {
                                shareButton.innerHTML = `❌ <span class="button-text">${t.progress.error}</span>`;
                            }
                        } finally {
                            setTimeout(() => {
                                shareButton.innerHTML = textoOriginal;
                                shareButton.disabled = false;
                            }, 2000);
                        }
                    });
                    actionsContainer.appendChild(shareButton);
                }
            }

            container.appendChild(actionsContainer);
        }

        function renderizarVigencia(container, createdAt) {
            if (!createdAt || typeof createdAt.toDate !== 'function') return;

            const fechaCreacion = createdAt.toDate();
            const hoy = new Date();
            const diffMilisegundos = hoy.getTime() - fechaCreacion.getTime();
            const diasPasados = Math.floor(diffMilisegundos / (1000 * 60 * 60 * 24));
            const vigenciaTotalDias = 30; // Configuración de días

            let diasRestantes = vigenciaTotalDias - diasPasados;
            if (diasRestantes < 0) diasRestantes = 0;

            const vigenciaElement = document.createElement('p');
            vigenciaElement.className = 'video-vigencia';

            // Color según urgencia: verde (holgado), ámbar (poco), rojo (crítico)
            if (diasRestantes <= 2) {
                vigenciaElement.classList.add('vigencia-danger');
            } else if (diasRestantes <= 7) {
                vigenciaElement.classList.add('vigencia-warn');
            } else {
                vigenciaElement.classList.add('vigencia-ok');
            }

            // Texto según idioma (misma lógica de antes)
            let textoVigencia;
            if (selectedLang === 'es') {
                textoVigencia = `Vigencia - ${diasRestantes} día${diasRestantes !== 1 ? 's' : ''}`;
            } else if (selectedLang === 'pt') {
                textoVigencia = `Válido por ${diasRestantes} dia${diasRestantes !== 1 ? 's' : ''}`;
            } else {
                textoVigencia = `Valid for ${diasRestantes} day${diasRestantes !== 1 ? 's' : ''}`;
            }

            const iconoReloj = '<svg class="vigencia-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
            vigenciaElement.innerHTML = `${iconoReloj}<span>${textoVigencia}</span>`;

            container.appendChild(vigenciaElement);
        }

        // --- Reacciones — SOLO en galería (video/collage individual no pasan ctx) ---
        const REACCIONES = [
            { tipo: 'heart', emoji: '❤️' },
            { tipo: 'love', emoji: '😍' },
            { tipo: 'laugh', emoji: '😂' },
            { tipo: 'fire', emoji: '🔥' },
            { tipo: 'clap', emoji: '👏' }
        ];
        const EMOJI_POR_TIPO = { heart: '❤️', love: '😍', laugh: '😂', fire: '🔥', clap: '👏' };

        function agregarReacciones(container, ctx) {
            if (!ctx || !ctx.ref) return;

            const bar = document.createElement('div');
            bar.className = 'reaction-bar';
            bar.dataset.mireaccion = '';
            bar._reactions = Object.assign({}, ctx.reactions || {});

            const trigger = document.createElement('button');
            trigger.type = 'button';
            trigger.className = 'reaction-trigger';
            trigger.setAttribute('aria-label', 'Reaccionar');

            const picker = document.createElement('div');
            picker.className = 'reaction-picker';
            REACCIONES.forEach((r) => {
                const b = document.createElement('button');
                b.type = 'button';
                b.className = 'reaction-option';
                b.dataset.tipo = r.tipo;
                b.textContent = r.emoji;
                b.setAttribute('aria-label', r.tipo);
                b.addEventListener('click', (e) => {
                    e.stopPropagation();
                    picker.classList.remove('open');
                    reaccionar(ctx, r.tipo, bar);
                });
                picker.appendChild(b);
            });

            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                picker.classList.toggle('open');
            });

            bar.appendChild(trigger);
            bar.appendChild(picker);
            container.appendChild(bar);

            pintarResumenReacciones(bar);

            // ¿Con qué reaccionó este dispositivo? (cuando la auth esté lista)
            authReady.then((uid) => {
                if (!uid) return;
                ctx.ref.collection('reactedBy').doc(uid).get()
                    .then((snap) => {
                        if (snap.exists && snap.data().tipo) {
                            bar.dataset.mireaccion = snap.data().tipo;
                            pintarResumenReacciones(bar);
                        }
                    }).catch(() => { });
            });
        }

        function pintarResumenReacciones(bar) {
            const reactions = bar._reactions || {};
            const trigger = bar.querySelector('.reaction-trigger');
            const mia = bar.dataset.mireaccion;

            let total = 0;
            let chips = '';
            REACCIONES.forEach((r) => {
                const n = reactions[r.tipo] || 0;
                if (n > 0) {
                    total += n;
                    const mine = (r.tipo === mia) ? ' mine' : '';
                    chips += `<span class="reaction-chip${mine}">${r.emoji}${n}</span>`;
                }
            });

            trigger.innerHTML = total > 0
                ? `<span class="reaction-chips">${chips}</span>`
                : `<span class="reaction-hint">🙂 Reaccionar</span>`;
            trigger.classList.toggle('reacted', !!mia);

            bar.querySelectorAll('.reaction-option').forEach((op) => {
                op.classList.toggle('selected', op.dataset.tipo === mia);
            });
        }

        async function reaccionar(ctx, tipo, bar) {
            const uid = await authReady;
            if (!uid) { mostrarToast('No pudimos registrar tu reacción, intenta de nuevo.'); return; }
            if (bar.dataset.busy === '1') return;
            bar.dataset.busy = '1';

            const actual = bar.dataset.mireaccion || '';
            const previoMapa = Object.assign({}, bar._reactions || {});
            const op = (actual === tipo) ? 'remove' : (actual ? 'change' : 'add');

            // Cálculo optimista (se siente instantáneo)
            const optimista = Object.assign({}, previoMapa);
            if (op === 'add') {
                optimista[tipo] = (optimista[tipo] || 0) + 1;
            } else if (op === 'remove') {
                optimista[tipo] = Math.max(0, (optimista[tipo] || 0) - 1);
                if (optimista[tipo] === 0) delete optimista[tipo];
            } else {
                optimista[actual] = Math.max(0, (optimista[actual] || 0) - 1);
                if (optimista[actual] === 0) delete optimista[actual];
                optimista[tipo] = (optimista[tipo] || 0) + 1;
            }
            bar._reactions = optimista;
            bar.dataset.mireaccion = (op === 'remove') ? '' : tipo;
            pintarResumenReacciones(bar);
            if (op !== 'remove') animarReaccion(bar);

            try {
                const ref = ctx.ref;
                const reactedByRef = ref.collection('reactedBy').doc(uid);
                const resultado = await db.runTransaction(async (tx) => {
                    const rbSnap = await tx.get(reactedByRef);
                    const docSnap = await tx.get(ref);
                    const mapa = (docSnap.exists && docSnap.data().reactions)
                        ? Object.assign({}, docSnap.data().reactions) : {};
                    const previa = rbSnap.exists ? (rbSnap.data().tipo || '') : '';

                    if (previa === tipo) {
                        // quitar
                        mapa[tipo] = Math.max(0, (mapa[tipo] || 0) - 1);
                        if (mapa[tipo] === 0) delete mapa[tipo];
                        tx.update(ref, { reactions: mapa });
                        tx.delete(reactedByRef);
                        return { mapa, mia: '' };
                    } else if (!previa) {
                        // agregar
                        mapa[tipo] = (mapa[tipo] || 0) + 1;
                        tx.update(ref, { reactions: mapa });
                        tx.set(reactedByRef, {
                            tipo: tipo, uid: uid,
                            createdAt: firebase.firestore.FieldValue.serverTimestamp()
                        });
                        return { mapa, mia: tipo };
                    } else {
                        // cambiar previa -> tipo
                        mapa[previa] = Math.max(0, (mapa[previa] || 0) - 1);
                        if (mapa[previa] === 0) delete mapa[previa];
                        mapa[tipo] = (mapa[tipo] || 0) + 1;
                        tx.update(ref, { reactions: mapa });
                        tx.update(reactedByRef, { tipo: tipo });
                        return { mapa, mia: tipo };
                    }
                });
                bar._reactions = resultado.mapa;
                bar.dataset.mireaccion = resultado.mia;
                pintarResumenReacciones(bar);
            } catch (e) {
                console.warn('No se pudo registrar la reacción:', e);
                bar._reactions = previoMapa;
                bar.dataset.mireaccion = actual;
                pintarResumenReacciones(bar);
                mostrarToast('No se pudo registrar tu reacción, intenta de nuevo.');
            } finally {
                bar.dataset.busy = '0';
            }
        }

        function animarReaccion(bar) {
            const trigger = bar.querySelector('.reaction-trigger');
            if (!trigger) return;
            trigger.classList.remove('pop');
            void trigger.offsetWidth; // reinicia la animación
            trigger.classList.add('pop');
        }

        // --- Visor de fotos (PhotoSwipe) para los collages de la galería ---
        function abrirLightboxCollages(indice) {
            const PhotoSwipeClase = window.PhotoSwipe;
            if (!PhotoSwipeClase) {
                // El visor aún no cargó: abrimos la imagen directa como respaldo
                const c = collagesLightbox[indice];
                if (c) window.open(c.src, '_blank');
                return;
            }

            const altTexto = (typeof t !== 'undefined' && t && t.media) ? t.media.photoAlt : 'Foto';
            const slides = collagesLightbox.map((c) => {
                const nw = (c.imgEl && c.imgEl.naturalWidth) || 1080;
                const nh = (c.imgEl && c.imgEl.naturalHeight) || 1920;
                const escala = 1920 / Math.max(nw, nh); // caja grande para permitir zoom nítido
                return {
                    src: c.src,
                    width: Math.round(nw * escala),
                    height: Math.round(nh * escala),
                    alt: altTexto
                };
            });

            const pswp = new PhotoSwipeClase({
                dataSource: slides,
                index: indice,
                bgOpacity: 0.92,
                showHideAnimationType: 'fade',
                wheelToZoom: true
            });

            // Botón de descarga dentro del visor
            pswp.on('uiRegister', () => {
                pswp.ui.registerElement({
                    name: 'descargar',
                    order: 9,
                    isButton: true,
                    tagName: 'a',
                    html: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin:18px 13px"><path d="M12 3v12"/><path d="M7 10l5 5 5-5"/><path d="M5 21h14"/></svg>',
                    onInit: (el) => {
                        el.setAttribute('target', '_blank');
                        el.setAttribute('rel', 'noopener');
                        el.setAttribute('download', '');
                        const actualizar = () => {
                            if (pswp.currSlide) el.href = pswp.currSlide.data.src;
                        };
                        pswp.on('change', actualizar);
                        actualizar();
                    }
                });
            });

            pswp.init();
        }


        // ================== VISTA DE MÚSICA (Parte 1) ==================
        function nombreCancion(c) {
            let nombre = (c && (c.title || c.fileName)) || 'Canción';
            nombre = nombre.replace(/\.[^/.]+$/, '');   // quita extensión (.mp3, etc.)
            nombre = nombre.replace(/_/g, ' ').trim();  // guiones bajos -> espacios
            return nombre || 'Canción';
        }

        // Bloquea la web con el Lottie de carga + un mensaje (p. ej. "Validando acceso")
        function mostrarBloqueoCarga(mensaje) {
            const loader = document.getElementById('loader');
            if (!loader) return;
            loader.style.display = 'flex';
            loader.style.flexDirection = 'column';
            let txt = document.getElementById('loader-text');
            if (!txt) {
                txt = document.createElement('div');
                txt.id = 'loader-text';
                txt.style.cssText = 'color:#ffffff; margin-top:16px; font-size:18px; font-weight:600; font-family:Arial,sans-serif; text-align:center;';
                loader.appendChild(txt);
            }
            txt.textContent = mensaje || '';
            txt.style.display = 'block';
        }

        function ocultarBloqueoCarga() {
            const loader = document.getElementById('loader');
            if (loader) { loader.style.display = 'none'; loader.style.flexDirection = 'row'; }
            const txt = document.getElementById('loader-text');
            if (txt) txt.style.display = 'none';
        }

        // Carga solo la cabecera del evento (logo, nombre, empresa/redes) sin
        // cargar videos ni selector — para la ruta /{eventId}/music directa.
        async function cargarCabeceraEvento(eventId) {
            try {
                const eventDocRef = db.collection('videogallery').doc(eventId);
                const eventDoc = await eventDocRef.get();
                if (!eventDoc.exists) return null;
                const eventData = eventDoc.data();
                colaHabilitada = eventData.colaUsuarios === true;
                colaConfirmacion = eventData.colaConfirmacion === true;
                await actualizarLogoSiExiste(eventData);
                mostrarLogo();
                const nombreEventoEl = document.getElementById('nombre-evento');
                let nombreEncontrado = false;
                if (eventData.nombre) {
                    nombreEventoEl.textContent = eventData.nombre;
                    nombreEventoEl.style.opacity = 1;
                    nombreEventoEl.style.display = "block";
                    nombreEncontrado = true;
                }
                if (eventData.empresa || eventData.instagram || eventData.whatsapp) {
                    actualizarHeaderConJsonData({ empresa: eventData.empresa, instagram: eventData.instagram, whatsapp: eventData.whatsapp });
                } else {
                    const jsonDoc = await eventDocRef.collection('empresaJSON').doc('1').get();
                    if (jsonDoc.exists) {
                        const j = jsonDoc.data();
                        if (!nombreEncontrado && j.nombreEvento) {
                            nombreEventoEl.textContent = j.nombreEvento;
                            nombreEventoEl.style.opacity = 1;
                            nombreEventoEl.style.display = "block";
                            nombreEncontrado = true;
                        }
                        if (j.jsonUrl) {
                            try { const r = await fetch(j.jsonUrl); actualizarHeaderConJsonData(await r.json()); }
                            catch (e) { actualizarHeaderConJsonData(null); }
                        } else { actualizarHeaderConJsonData(null); }
                    } else { actualizarHeaderConJsonData(null); }
                }
                if (!nombreEncontrado) nombreEventoEl.textContent = t.gallery.defaultTitle;
                return eventData;
            } catch (e) {
                console.error("Error cargando la cabecera del evento:", e);
                return null;
            }
        }

        // Muestra un panel principal (token / list / queue) ocultando los demás.
        // El panel "join" se muestra aparte (sobre la lista) al elegir canción.
        function mostrarPanelMusica(cual) {
            ['music-token', 'music-list', 'music-join', 'music-queue'].forEach((id) => {
                const el = document.getElementById(id);
                if (el) el.classList.add('hidden');
            });
            const el = document.getElementById('music-' + cual);
            if (el) el.classList.remove('hidden');
        }

        function mostrarVistaMusica(eventId) {
            eventoMusicaId = eventId;
            document.body.classList.add('modo-musica');
            window.scrollTo(0, 0);

            // 1. Persistencia: ¿ya estoy en la fila? (aunque recargue)
            let entryId = null;
            try { entryId = localStorage.getItem('colaEntry_' + eventId); } catch (e) { entryId = null; }
            if (entryId) { mostrarVistaFila(eventId, entryId); return; }

            // 2. ¿Canciones ya cargadas en esta sesión? (evita re-pedir)
            const lista = document.getElementById('music-list');
            if (lista && !lista.classList.contains('hidden')) return;

            // 3. Código cacheado (< 8h) → auto-cargar; si no, pedir el código
            let cache = null;
            try { cache = JSON.parse(localStorage.getItem('musicAuth_' + eventId)); } catch (e) { cache = null; }
            if (cache && cache.token && (Date.now() - cache.ts) < MUSIC_TTL_MS) {
                pedirCanciones(eventId, cache.token, true);
            } else {
                try { localStorage.removeItem('musicAuth_' + eventId); } catch (e) { }
                mostrarPanelMusica('token');
            }
        }

        function ocultarVistaMusica() {
            document.body.classList.remove('modo-musica');
            desuscribirCola();
            if (audioMusica && !audioMusica.paused) {
                audioMusica.pause();
                if (botonPlayActivo) { botonPlayActivo.textContent = '▶'; botonPlayActivo = null; }
            }
        }

        function irAMusica(eventId) {
            history.pushState({ view: 'music' }, '', '/' + eventId + '/music');
            mostrarVistaMusica(eventId);
        }

        function volverDeMusica() {
            if (galleryYaCargada) {
                history.back(); // popstate restaura la galería ya cargada
            } else {
                window.location.href = '/' + eventoMusicaId; // carga directa: vamos a la galería
            }
        }

        async function pedirCanciones(eventId, token, desdeCache) {
            const btn = document.getElementById('music-token-btn');
            const errorEl = document.getElementById('music-token-error');
            if (errorEl) errorEl.textContent = '';
            if (btn) { btn.disabled = true; btn.textContent = 'Verificando...'; }
            mostrarBloqueoCarga('Validando acceso');
            try {
                const getEventSongs = firebase.functions().httpsCallable('getEventSongs');
                const res = await getEventSongs({ eventId: eventId, token: token });
                const canciones = (res.data && res.data.canciones) || [];
                // Guardar el código válido en caché (vigencia de 8h)
                try { localStorage.setItem('musicAuth_' + eventId, JSON.stringify({ token: token, ts: Date.now() })); } catch (e) { }
                renderCanciones(canciones);
            } catch (e) {
                console.warn('Error al pedir canciones:', e);
                try { localStorage.removeItem('musicAuth_' + eventId); } catch (er) { }
                const tokenPanel = document.getElementById('music-token');
                const lista = document.getElementById('music-list');
                if (desdeCache) {
                    // El código cacheado ya no sirve: volvemos a pedirlo
                    if (tokenPanel) tokenPanel.classList.remove('hidden');
                    if (lista) lista.classList.add('hidden');
                } else if (errorEl) {
                    errorEl.textContent = 'Código incorrecto o no se pudieron cargar las canciones.';
                }
            } finally {
                ocultarBloqueoCarga();
                if (btn) { btn.disabled = false; btn.textContent = 'Ver canciones'; }
            }
        }

        function renderCanciones(canciones) {
            const cont = document.getElementById('music-list');
            const tokenPanel = document.getElementById('music-token');
            if (!cont) return;
            cont.innerHTML = '';

            if (!canciones.length) {
                const vacio = document.createElement('p');
                vacio.className = 'music-empty';
                vacio.textContent = 'No hay canciones disponibles para este evento.';
                cont.appendChild(vacio);
            } else {
                canciones.forEach((c) => {
                    const item = document.createElement('div');
                    item.className = 'music-item';

                    const playBtn = document.createElement('button');
                    playBtn.className = 'music-play';
                    playBtn.setAttribute('aria-label', 'Reproducir');
                    playBtn.textContent = '▶';

                    const titulo = document.createElement('span');
                    titulo.className = 'music-title';
                    titulo.textContent = nombreCancion(c);

                    const chooseBtn = document.createElement('button');
                    chooseBtn.className = 'music-choose';
                    chooseBtn.textContent = 'Elegir';

                    playBtn.addEventListener('click', () => reproducirCancion(c, playBtn));
                    chooseBtn.addEventListener('click', () => elegirCancion(c, item));

                    item.appendChild(playBtn);
                    item.appendChild(titulo);
                    item.appendChild(chooseBtn);
                    cont.appendChild(item);
                });
            }

            mostrarPanelMusica('list');
        }

        function reproducirCancion(c, playBtn) {
            if (!audioMusica) {
                audioMusica = new Audio();
                audioMusica.addEventListener('ended', () => {
                    if (botonPlayActivo) { botonPlayActivo.textContent = '▶'; botonPlayActivo = null; }
                });
            }
            if (botonPlayActivo === playBtn) {
                if (audioMusica.paused) { audioMusica.play().catch(() => { }); playBtn.textContent = '⏸'; }
                else { audioMusica.pause(); playBtn.textContent = '▶'; }
                return;
            }
            if (botonPlayActivo) botonPlayActivo.textContent = '▶';
            audioMusica.src = c.cloudUrl;
            audioMusica.play().catch(() => { });
            playBtn.textContent = '⏸';
            botonPlayActivo = playBtn;
        }

        function getCachedToken(eventId) {
            try { const c = JSON.parse(localStorage.getItem('musicAuth_' + eventId)); return c && c.token; } catch (e) { return null; }
        }

        function abrirModalJoin(modo) {
            modoModal = modo;
            const join = document.getElementById('music-join');
            const txt = document.getElementById('music-join-cancion');
            const nombreInput = document.getElementById('music-join-nombre');
            const btn = document.getElementById('music-join-btn');
            const errorEl = document.getElementById('music-join-error');
            if (errorEl) errorEl.textContent = '';
            if (txt) txt.textContent = nombreCancion(cancionElegida || {});
            if (modo === 'cambio') {
                if (nombreInput) nombreInput.style.display = 'none';
                if (btn) btn.textContent = 'Guardar cambio';
            } else {
                if (nombreInput) nombreInput.style.display = '';
                if (btn) btn.textContent = 'Unirme a la fila';
            }
            if (join) join.classList.remove('hidden');
        }

        function cerrarModalJoin() {
            const join = document.getElementById('music-join');
            if (join) join.classList.add('hidden');
            if (cambiandoCancion) { cambiandoCancion = false; mostrarPanelMusica('queue'); }
        }

        function elegirCancion(c, item) {
            cancionElegida = c;
            document.querySelectorAll('#music-list .music-item').forEach((i) => i.classList.remove('elegida'));
            item.classList.add('elegida');
            if (colaHabilitada) {
                abrirModalJoin(cambiandoCancion ? 'cambio' : 'join');
            } else {
                mostrarToast('Canción seleccionada: ' + nombreCancion(c));
            }
        }

        function iniciarCambioCancion() {
            cambiandoCancion = true;
            const lista = document.getElementById('music-list');
            if (lista && lista.querySelector('.music-item')) {
                mostrarPanelMusica('list');
            } else {
                const token = getCachedToken(eventoMusicaId);
                if (token) pedirCanciones(eventoMusicaId, token, true);
                else mostrarPanelMusica('token');
            }
        }

        async function guardarCambioCancion() {
            if (!cancionElegida || !miEntradaId || !eventoMusicaId) return;
            const errorEl = document.getElementById('music-join-error');
            const btn = document.getElementById('music-join-btn');
            if (btn) { btn.disabled = true; btn.textContent = 'Guardando...'; }
            mostrarBloqueoCarga('Cambiando canción');
            try {
                await db.collection('videogallery').doc(eventoMusicaId).collection('cola').doc(miEntradaId)
                    .update({
                        cancion: {
                            title: cancionElegida.title || '',
                            fileName: cancionElegida.fileName || '',
                            cloudUrl: cancionElegida.cloudUrl || ''
                        }
                    });
                cambiandoCancion = false;
                const join = document.getElementById('music-join');
                if (join) join.classList.add('hidden');
                mostrarPanelMusica('queue');
                mostrarToast('Canción actualizada');
            } catch (e) {
                console.warn('No se pudo cambiar la canción:', e);
                if (errorEl) errorEl.textContent = 'No se pudo cambiar la canción, intenta de nuevo.';
            } finally {
                ocultarBloqueoCarga();
                if (btn) { btn.disabled = false; }
            }
        }

        // ---- Fila de música (Parte 2) ----
        async function unirseALaFila() {
            const nombreEl = document.getElementById('music-join-nombre');
            const errorEl = document.getElementById('music-join-error');
            const btn = document.getElementById('music-join-btn');
            if (errorEl) errorEl.textContent = '';
            const nombre = (nombreEl && nombreEl.value.trim()) || '';
            if (!nombre) { if (errorEl) errorEl.textContent = 'Escribe tu nombre.'; return; }
            if (!cancionElegida) { if (errorEl) errorEl.textContent = 'Elige una canción primero.'; return; }
            let token = null;
            try { const c = JSON.parse(localStorage.getItem('musicAuth_' + eventoMusicaId)); token = c && c.token; } catch (e) { token = null; }
            if (!token) { if (errorEl) errorEl.textContent = 'Vuelve a ingresar el código.'; return; }

            if (btn) { btn.disabled = true; btn.textContent = 'Uniéndote...'; }
            mostrarBloqueoCarga('Uniéndote a la fila');
            try {
                const unirse = firebase.functions().httpsCallable('unirseColaMusica');
                const res = await unirse({
                    eventId: eventoMusicaId,
                    token: token,
                    nombre: nombre,
                    cancion: {
                        title: cancionElegida.title || '',
                        fileName: cancionElegida.fileName || '',
                        cloudUrl: cancionElegida.cloudUrl || ''
                    }
                });
                const entryId = res.data && res.data.entryId;
                if (entryId) {
                    try { localStorage.setItem('colaEntry_' + eventoMusicaId, entryId); } catch (e) { }
                    mostrarVistaFila(eventoMusicaId, entryId);
                } else if (errorEl) {
                    errorEl.textContent = 'No se pudo unir a la fila, intenta de nuevo.';
                }
            } catch (e) {
                console.warn('Error al unirse a la fila:', e);
                if (errorEl) errorEl.textContent = 'No se pudo unir a la fila, intenta de nuevo.';
            } finally {
                ocultarBloqueoCarga();
                if (btn) { btn.disabled = false; btn.textContent = 'Unirme a la fila'; }
            }
        }

        function mostrarVistaFila(eventId, entryId) {
            miEntradaId = entryId;
            mostrarPanelMusica('queue');
            suscribirCola(eventId, entryId);
        }

        function suscribirCola(eventId, entryId) {
            desuscribirCola();
            unsubCola = db.collection('videogallery').doc(eventId).collection('cola')
                .orderBy('createdAt')
                .onSnapshot((snap) => renderCola(snap, entryId), (err) => console.warn('Listener cola:', err));
            unsubEstado = db.collection('videogallery').doc(eventId).collection('colaEstado').doc('app')
                .onSnapshot((doc) => renderAppEstado(doc), (err) => console.warn('Listener estado:', err));
        }

        function desuscribirCola() {
            if (unsubCola) { unsubCola(); unsubCola = null; }
            if (unsubEstado) { unsubEstado(); unsubEstado = null; }
        }

        function etiquetaEstado(e) {
            if (e === 'turno') return 'Tu turno';
            if (e === 'confirmado') return 'Confirmado';
            if (e === 'en_proceso') return 'En proceso';
            if (e === 'listo') return 'Listo';
            if (e === 'cedido') return 'Cedió';
            return 'Esperando';
        }

        function renderAppEstado(doc) {
            const el = document.getElementById('music-app-estado');
            if (!el) return;
            const data = (doc && doc.exists) ? doc.data() : null;
            const estado = data && data.estado;
            if (estado === 'grabando') el.textContent = '🎥 La cámara está grabando un video…';
            else if (estado === 'editando') el.textContent = '✨ Editando un video…';
            else el.textContent = 'La cámara está libre.';
        }

        function renderCola(snap, miId) {
            const listaEl = document.getElementById('music-cola-lista');
            if (!listaEl) return;

            const entradas = [];
            snap.forEach((d) => entradas.push(Object.assign({ id: d.id }, d.data())));

            const mia = entradas.find((e) => e.id === miId);
            renderMiEstado(mia, entradas, miId);

            const activos = entradas.filter((e) => e.estado !== 'listo' && e.estado !== 'cedido');
            listaEl.innerHTML = '';
            if (!activos.length) {
                listaEl.innerHTML = '<p class="music-empty">La fila está vacía.</p>';
                return;
            }
            activos.forEach((e, idx) => {
                const row = document.createElement('div');
                row.className = 'cola-item' + (e.id === miId ? ' mia' : '');

                const pos = document.createElement('span');
                pos.className = 'cola-pos';
                pos.textContent = (idx + 1);

                const nom = document.createElement('span');
                nom.className = 'cola-nombre';
                nom.textContent = e.nombre || 'Invitado';

                const est = document.createElement('span');
                est.className = 'cola-estado est-' + (e.estado || '');
                est.textContent = etiquetaEstado(e.estado);

                row.appendChild(pos);
                row.appendChild(nom);
                row.appendChild(est);
                listaEl.appendChild(row);
            });
        }

        function renderMiEstado(mia, entradas, miId) {
            const el = document.getElementById('music-mi-estado');
            if (!el) return;

            if (!mia) {
                el.innerHTML = '<div class="mi-estado-box listo"><p>Tu turno finalizó. Revisa tu video en la galería. 🎉</p><button id="music-otra" class="music-choose" type="button">Elegir otra canción</button></div>';
                const otra = document.getElementById('music-otra');
                if (otra) otra.addEventListener('click', salirDeLaFila);
                try { localStorage.removeItem('colaEntry_' + eventoMusicaId); } catch (e) { }
                return;
            }

            if (mia.estado === 'turno') {
                if (colaConfirmacion) {
                    el.innerHTML = '<div class="mi-estado-box turno"><p>¡Es tu turno! ¿Sigues tú?</p><div class="turno-btns"><button id="btn-sigo" class="music-choose" type="button">Sí, sigo yo</button><button id="btn-cedo" class="music-back" type="button">Cedo mi turno</button></div></div>';
                    const sigo = document.getElementById('btn-sigo');
                    const cedo = document.getElementById('btn-cedo');
                    if (sigo) sigo.addEventListener('click', () => actualizarMiEstado('confirmado'));
                    if (cedo) cedo.addEventListener('click', () => actualizarMiEstado('cedido'));
                } else {
                    el.innerHTML = '<div class="mi-estado-box turno"><p>¡Es tu turno! 🎬</p></div>';
                }
            } else if (mia.estado === 'confirmado') {
                el.innerHTML = '<div class="mi-estado-box proceso"><p>Confirmado. Preparando tu video…</p></div>';
            } else if (mia.estado === 'en_proceso') {
                el.innerHTML = '<div class="mi-estado-box proceso"><p>Tu video está en proceso… 🎬</p></div>';
            } else if (mia.estado === 'cedido') {
                el.innerHTML = '<div class="mi-estado-box"><p>Cediste tu turno.</p><button id="music-otra" class="music-choose" type="button">Volver a elegir</button></div>';
                const otra = document.getElementById('music-otra');
                if (otra) otra.addEventListener('click', salirDeLaFila);
            } else {
                const pendientes = entradas.filter((e) => e.estado === 'esperando' || e.estado === 'turno' || e.estado === 'confirmado' || e.estado === 'en_proceso');
                const pos = pendientes.findIndex((e) => e.id === miId) + 1;
                el.innerHTML = '<div class="mi-estado-box"><p>Vas en el puesto <strong>' + pos + '</strong> de la fila.</p><p class="mi-cancion">Tu canción: ' + nombreCancion(mia.cancion || {}) + '</p><button id="music-cambiar" class="music-choose" type="button">Cambiar canción</button></div>';
                const cambiar = document.getElementById('music-cambiar');
                if (cambiar) cambiar.addEventListener('click', iniciarCambioCancion);
            }
        }

        async function actualizarMiEstado(nuevo) {
            if (!miEntradaId || !eventoMusicaId) return;
            try {
                await db.collection('videogallery').doc(eventoMusicaId).collection('cola').doc(miEntradaId).update({ estado: nuevo });
            } catch (e) {
                console.warn('No se pudo actualizar el estado:', e);
                mostrarToast('No se pudo actualizar, intenta de nuevo.');
            }
        }

        function salirDeLaFila() {
            try { localStorage.removeItem('colaEntry_' + eventoMusicaId); } catch (e) { }
            miEntradaId = null;
            desuscribirCola();
            const lista = document.getElementById('music-list');
            if (lista) lista.classList.add('hidden');
            mostrarVistaMusica(eventoMusicaId);
        }

        function configurarBotonesMusica() {
            const btnMusica = document.getElementById('music-button');
            if (btnMusica) {
                btnMusica.addEventListener('click', () => {
                    if (galleryIdActual) irAMusica(galleryIdActual);
                });
            }
            const joinBtn = document.getElementById('music-join-btn');
            const joinNombre = document.getElementById('music-join-nombre');
            if (joinBtn) {
                joinBtn.addEventListener('click', () => {
                    if (modoModal === 'cambio') guardarCambioCancion();
                    else unirseALaFila();
                });
            }
            if (joinNombre) {
                joinNombre.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') { e.preventDefault(); if (joinBtn) joinBtn.click(); }
                });
            }
            const joinClose = document.getElementById('music-join-close');
            if (joinClose) joinClose.addEventListener('click', cerrarModalJoin);
            const mTokenBtn = document.getElementById('music-token-btn');
            const mTokenInput = document.getElementById('music-token-input');
            if (mTokenBtn && mTokenInput) {
                mTokenBtn.addEventListener('click', () => {
                    const tok = mTokenInput.value.trim();
                    if (tok) pedirCanciones(eventoMusicaId, tok);
                });
                mTokenInput.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') { e.preventDefault(); mTokenBtn.click(); }
                });
            }
            const mBack = document.getElementById('music-back');
            if (mBack) mBack.addEventListener('click', volverDeMusica);

            window.addEventListener('popstate', () => {
                const parts = window.location.pathname.split('/').filter((p) => p !== '');
                if (parts.length === 2 && parts[1] === 'music') mostrarVistaMusica(parts[0]);
                else ocultarVistaMusica();
            });
        }
        // ================== FIN VISTA DE MÚSICA ==================

        window.onload = function () {
            const loader = document.getElementById('loader');
            const videoListContainer = document.getElementById('video-list');
            const selector = document.getElementById('media-selector');

            if (loader) loader.style.display = 'flex';

            configurarBotonesMusica();

            const pathParts = window.location.pathname.split('/').filter(part => part !== '');

            if (pathParts.length === 2 && pathParts[0] === 'video') {
                if (selector) selector.style.display = 'none';
                const videoId = pathParts[1];
                videoListContainer.classList.add('single-video-mode');
                cargarVideoIndividual(videoId)
                    .finally(() => {
                        if (loader) loader.style.display = 'none';
                        mostrarFooter();
                    });

            } else if (pathParts.length === 2 && pathParts[0] === 'collage') {
                if (selector) selector.style.display = 'none';
                const collageId = pathParts[1];
                videoListContainer.classList.add('single-video-mode');
                cargarCollageIndividual(collageId)
                    .finally(() => {
                        if (loader) loader.style.display = 'none';
                        mostrarFooter();
                    });

            } else if (pathParts.length === 2 && pathParts[1] === 'music') {
                if (selector) selector.style.display = 'none';
                const eventId = pathParts[0];
                cargarCabeceraEvento(eventId).then((eventData) => {
                    if (loader) loader.style.display = 'none';
                    // Si la música no está habilitada para el evento, a la galería
                    if (!eventData || eventData.musicaUser !== true) {
                        window.location.replace('/' + eventId);
                        return;
                    }
                    mostrarVistaMusica(eventId);
                    mostrarFooter();
                }).catch(() => {
                    if (loader) loader.style.display = 'none';
                    window.location.replace('/' + eventId);
                });

            } else if (pathParts.length === 1) {
                const galleryId = pathParts[0];
                videoListContainer.classList.remove('single-video-mode');
                iniciarCargaGaleria(galleryId);

            } else {
                window.location.replace('https://app.spin360app.com');
            }
        };

        window.cambiarPestaña = function (tipo) {
            // Recordar la pestaña activa para restaurarla al recargar (solo galería)
            if (galleryIdActual) {
                try { localStorage.setItem('lastTab_' + galleryIdActual, tipo); } catch (e) { }
            }

            const btnVideos = document.getElementById('btn-tab-videos');
            const btnCollages = document.getElementById('btn-tab-collages');
            const btnFinales = document.getElementById('btn-tab-finales');

            const videoList = document.getElementById('video-list');
            const collageList = document.getElementById('collage-list');
            const finalList = document.getElementById('final-list');

            btnVideos.classList.remove('active');
            btnCollages.classList.remove('active');
            btnFinales.classList.remove('active');

            videoList.classList.add('hidden');
            videoList.style.display = 'none';
            collageList.classList.add('hidden');
            collageList.style.display = 'none';
            finalList.classList.add('hidden');
            finalList.style.display = 'none';

            if (tipo === 'videos') {
                btnVideos.classList.add('active');
                videoList.classList.remove('hidden');
                videoList.style.display = 'flex';
                actualizarContadorMedia('videos');

            } else if (tipo === 'collages') {
                btnCollages.classList.add('active');
                collageList.classList.remove('hidden');
                collageList.style.display = 'flex';
                actualizarContadorMedia('collages');

                if (!collagesCargados && galleryIdActual) {
                    const loader = document.getElementById('loader');
                    if (loader) loader.style.display = 'flex';
                    cargarCollages(galleryIdActual).then(() => {
                        if (loader) loader.style.display = 'none';
                    });
                }

            } else if (tipo === 'finales') {
                btnFinales.classList.add('active');
                finalList.classList.remove('hidden');
                finalList.style.display = 'flex';
                actualizarContadorMedia('finales');

                if (!finalesCargados && galleryIdActual) {
                    const loader = document.getElementById('loader');
                    if (loader) loader.style.display = 'flex';
                    cargarFinales(galleryIdActual).then(() => {
                        if (loader) loader.style.display = 'none';
                    });
                }
            }
        };

    } catch (initError) {
        console.error("Error grave al iniciar la aplicación:", initError);
        const loaderOnError = document.getElementById('loader');
        if (loaderOnError) loaderOnError.style.display = 'none';
        const mensajeErrorFatal = (typeof t !== 'undefined' && t && t.fatalError)
            ? t.fatalError
            : "Ocurrió un error grave al iniciar. Por favor, contacta al soporte.";
        document.body.innerHTML = `<p>${mensajeErrorFatal}</p>`;
    }
}


function showIosInstructions() {
    const modal = document.getElementById('ios-instructions-modal');
    if (!modal) return;

    modal.classList.remove('hidden');

    const closeBtn = modal.querySelector('.modal-close');
    if (closeBtn) {
        closeBtn.onclick = () => modal.classList.add('hidden');
    }

    const okBtn = modal.querySelector('#modal-ok-button');
    if (okBtn) {
        okBtn.onclick = () => modal.classList.add('hidden');
    }

    modal.onclick = (event) => {
        if (event.target === modal) {
            modal.classList.add('hidden');
        }
    };
}

const translations = {
    es: {
        modal: { title: "Pasos para guardar tu video", intro: "Desde el menú de compartir puedes enviarlo directamente a tus redes sociales o guardarlo en tu dispositivo:", steps: ['Para guardarlo en tu galería, desliza hacia abajo y elige "<strong>Guardar video</strong>".', 'Para guardarlo en tus documentos, elige "<strong>Guardar en Archivos</strong>".'], button: "¡Entendido!" },
        global: { download: "Descargar", share: "Compartir", sharing_prep: "Preparando...", shareAndDownload: "Comparte y Descarga" },
        gallery: {
            noVideos: "No hay videos disponibles para este evento.",
            noCollages: "No hay collages disponibles para este evento.",
            noFinals: "Aún no hay videos finales para este evento.",
            notFoundTitle: "Galería no encontrada",
            notFoundText: "El evento que buscas no existe o ha sido eliminado.",
            loadError: "Ocurrió un error al cargar el evento. Intenta de nuevo más tarde.",
            defaultTitle: "Galería de Videos"
        },
        individual: {
            videoNotFound: "El video que buscas no existe o ha sido eliminado",
            collageNotFound: "El collage que buscas no existe o ha sido eliminado."
        },
        media: {
            videoLoadError: "No se pudo cargar el video.",
            thumbnailAlt: (nombre) => `Miniatura de ${nombre}`,
            photoAlt: "Foto del evento"
        },
        password: {
            enterPassword: "Por favor, introduce una contraseña",
            genericError: "Ocurrió un error.",
            connectionError: "Hubo un problema de conexión. Inténtalo de nuevo.",
            tryAgain: "Puedes intentar de nuevo.",
            tooManyAttempts: (minutes, seconds) => `Demasiados intentos. Intenta de nuevo en ${minutes}m ${seconds}s.`,
            verifying: "Verificando...",
            enter: "Entrar"
        },
        progress: {
            preparingZero: "Preparando... 0%",
            downloading: (porcentaje) => `Descargando... ${porcentaje}%`,
            downloadingVideo: "Descargando video...",
            ready: "¡Listo! Abriendo menú...",
            preparing: "Preparando...",
            downloadingShort: (porcentaje) => `Descargando ${porcentaje}%`,
            downloadingNoPct: "Descargando...",
            saved: "¡Guardado!",
            readyShort: "¡Listo!",
            readyShareTap: "¡Listo! Toca para Compartir",
            preparingPct: (porcentaje) => `Preparando ${porcentaje}%`,
            error: "Error"
        },
        share: {
            title: "¡Mira mi recuerdo 360!",
            text: "¡Mira mi recuerdo 360! 🥳",
            videoDownloadedAlert: "¡Video descargado correctamente!\n\nToca el botón verde de nuevo para abrir el menú de iOS.",
            whatsappMessage: "Hola, me gustaría cotizar un evento 360, ¿me puede dar información?",
            cta: "¿Te gusta este evento? Contáctanos y haz de tu fiesta algo inolvidable ✨"
        },
        fatalError: "Ocurrió un error grave al iniciar. Por favor, contacta al soporte."
    },
    en: {
        modal: { title: "Steps to save your video", intro: "From the share menu, you can send it directly to social media or save it to your device:", steps: ['To save to your photo gallery, scroll down and choose "<strong>Save Video</strong>".', 'To save to your documents, choose "<strong>Save to Files</strong>".'], button: "Got it!" },
        global: { download: "Download", share: "Share", sharing_prep: "Preparing...", shareAndDownload: "Share & Download" },
        gallery: {
            noVideos: "There are no videos available for this event.",
            noCollages: "There are no collages available for this event.",
            noFinals: "There are no final videos for this event yet.",
            notFoundTitle: "Gallery not found",
            notFoundText: "The event you are looking for does not exist or has been deleted.",
            loadError: "An error occurred while loading the event. Please try again later.",
            defaultTitle: "Video Gallery"
        },
        individual: {
            videoNotFound: "The video you are looking for does not exist or has been deleted.",
            collageNotFound: "The collage you are looking for does not exist or has been deleted."
        },
        media: {
            videoLoadError: "The video could not be loaded.",
            thumbnailAlt: (nombre) => `Thumbnail of ${nombre}`,
            photoAlt: "Event photo"
        },
        password: {
            enterPassword: "Please enter a password",
            genericError: "An error occurred.",
            connectionError: "There was a connection problem. Please try again.",
            tryAgain: "You can try again.",
            tooManyAttempts: (minutes, seconds) => `Too many attempts. Try again in ${minutes}m ${seconds}s.`,
            verifying: "Verifying...",
            enter: "Enter"
        },
        progress: {
            preparingZero: "Preparing... 0%",
            downloading: (porcentaje) => `Downloading... ${porcentaje}%`,
            downloadingVideo: "Downloading video...",
            ready: "Done! Opening menu...",
            preparing: "Preparing...",
            downloadingShort: (porcentaje) => `Downloading ${porcentaje}%`,
            downloadingNoPct: "Downloading...",
            saved: "Saved!",
            readyShort: "Done!",
            readyShareTap: "Done! Tap to Share",
            preparingPct: (porcentaje) => `Preparing ${porcentaje}%`,
            error: "Error"
        },
        share: {
            title: "Check out my 360 memory!",
            text: "Check out my 360 memory! 🥳",
            videoDownloadedAlert: "Video downloaded successfully!\n\nTap the green button again to open the iOS menu.",
            whatsappMessage: "Hi, I'd like to get a quote for a 360 event. Could you give me some information?",
            cta: "Enjoying this event? Contact us and make your party unforgettable ✨"
        },
        fatalError: "A serious error occurred while starting. Please contact support."
    },
    pt: {
        modal: { title: "Passos para salvar seu vídeo", intro: "No menu de compartilhamento, você pode enviá-lo diretamente para redes sociais ou salvá-lo no seu dispositivo:", steps: ['Para salvar na sua galeria de fotos, deslize para baixo e escolha "<strong>Salvar vídeo</strong>".', 'Para salvar em seus documentos, escolha "<strong>Salvar em Arquivos</strong>".'], button: "Entendido!" },
        global: { download: "Baixar", share: "Compartilhar", sharing_prep: "Preparando...", shareAndDownload: "Compartilhar e Baixar" },
        gallery: {
            noVideos: "Não há vídeos disponíveis para este evento.",
            noCollages: "Não há collages disponíveis para este evento.",
            noFinals: "Ainda não há vídeos finais para este evento.",
            notFoundTitle: "Galeria não encontrada",
            notFoundText: "O evento que você procura não existe ou foi excluído.",
            loadError: "Ocorreu um erro ao carregar o evento. Tente novamente mais tarde.",
            defaultTitle: "Galeria de Vídeos"
        },
        individual: {
            videoNotFound: "O vídeo que você procura não existe ou foi excluído.",
            collageNotFound: "O collage que você procura não existe ou foi excluído."
        },
        media: {
            videoLoadError: "Não foi possível carregar o vídeo.",
            thumbnailAlt: (nombre) => `Miniatura de ${nombre}`,
            photoAlt: "Foto do evento"
        },
        password: {
            enterPassword: "Por favor, digite uma senha",
            genericError: "Ocorreu um erro.",
            connectionError: "Houve um problema de conexão. Tente novamente.",
            tryAgain: "Você pode tentar de novo.",
            tooManyAttempts: (minutes, seconds) => `Muitas tentativas. Tente novamente em ${minutes}m ${seconds}s.`,
            verifying: "Verificando...",
            enter: "Entrar"
        },
        progress: {
            preparingZero: "Preparando... 0%",
            downloading: (porcentaje) => `Baixando... ${porcentaje}%`,
            downloadingVideo: "Baixando vídeo...",
            ready: "Pronto! Abrindo menu...",
            preparing: "Preparando...",
            downloadingShort: (porcentaje) => `Baixando ${porcentaje}%`,
            downloadingNoPct: "Baixando...",
            saved: "Salvo!",
            readyShort: "Pronto!",
            readyShareTap: "Pronto! Toque para Compartilhar",
            preparingPct: (porcentaje) => `Preparando ${porcentaje}%`,
            error: "Erro"
        },
        share: {
            title: "Veja a minha lembrança 360!",
            text: "Veja a minha lembrança 360! 🥳",
            videoDownloadedAlert: "Vídeo baixado com sucesso!\n\nToque no botão verde novamente para abrir o menu do iOS.",
            whatsappMessage: "Olá, gostaria de fazer um orçamento de um evento 360, pode me dar informações?",
            cta: "Está gostando deste evento? Fale conosco e torne sua festa inesquecível ✨"
        },
        fatalError: "Ocorreu um erro grave ao iniciar. Por favor, entre em contato com o suporte."
    }
};

function aplicarIdioma() {
    const lang = (navigator.language || navigator.userLanguage || "en").substring(0, 2);
    selectedLang = ["es", "en", "pt"].includes(lang) ? lang : "en";
    t = translations[selectedLang];

    document.documentElement.lang = selectedLang;

    const modal = document.getElementById("ios-instructions-modal");
    if (modal) {
        modal.querySelector("h3").textContent = t.modal.title;
        modal.querySelector("p").textContent = t.modal.intro;
        const ol = modal.querySelector("ol");
        ol.innerHTML = "";
        t.modal.steps.forEach(step => {
            const li = document.createElement("li");
            li.innerHTML = step;
            ol.appendChild(li);
        });
        modal.querySelector("#modal-ok-button").textContent = t.modal.button;
    }
}


function actualizarLogoSiExiste(data) {
    return new Promise((resolve) => {
        const logoImg = document.querySelector('.logo-container .logo');
        if (!logoImg) return resolve();

        const urlFinal = (data && data.logoUrl) ? data.logoUrl : "/images/Logo_Actual_Spin.png";

        const imgTemporal = new Image();
        imgTemporal.src = urlFinal;

        imgTemporal.onload = () => {
            logoImg.src = urlFinal;

            if (data && data.logoUrl) {
                document.body.style.background = `url('${urlFinal}') center/contain no-repeat fixed, #f4f4f4`;
                document.body.style.backgroundBlendMode = 'overlay';
            }
            resolve();
        };

        imgTemporal.onerror = () => {
            console.warn("No se pudo cargar el logo, usando el por defecto.");
            logoImg.src = "/images/Logo_Actual_Spin.png";
            resolve();
        };
    });
}

function mostrarLogo() {
    const logoContainer = document.querySelector('.logo-container');
    if (logoContainer) {
        logoContainer.style.opacity = '1';
        logoContainer.style.pointerEvents = 'auto';
    }
}

function ocultarLogoInicialmente() {
    const logoContainer = document.querySelector('.logo-container');
    if (logoContainer) {
        logoContainer.style.transition = 'opacity 0.8s ease-in-out';
        logoContainer.style.opacity = '0';
        logoContainer.style.pointerEvents = 'none';
    }
}

function mostrarFooter() {
    const footer = document.getElementById('site-footer');
    if (footer) {
        footer.style.display = 'block';
        setTimeout(() => {
            footer.classList.remove('footer-hidden');
        }, 50);
    }
}

let whatsappCtaTimer = null;

function mostrarWhatsappCta() {
    const cta = document.getElementById('whatsapp-cta');
    if (!cta) return;

    cta.classList.add('visible');
    cta.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-wa-cta');

    const textoEl = cta.querySelector('.cta-text');
    const mensaje = (typeof t !== 'undefined' && t && t.share && t.share.cta) ? t.share.cta : '';
    if (!textoEl || !mensaje) return;

    if (whatsappCtaTimer !== null) return;

    const velocidad = 45;
    const velocidadBorrado = 25;
    const pausaVisible = 5000;
    const pausaInicio = 700;

    const escribir = () => {
        cta.classList.remove('typing-done');
        let i = 0;
        const teclear = () => {
            if (i <= mensaje.length) {
                textoEl.textContent = mensaje.slice(0, i);
                i++;
                whatsappCtaTimer = setTimeout(teclear, velocidad);
            } else {
                cta.classList.add('typing-done');
                whatsappCtaTimer = setTimeout(borrar, pausaVisible);
            }
        };
        teclear();
    };

    const borrar = () => {
        cta.classList.remove('typing-done');
        let i = mensaje.length;
        const desteclear = () => {
            if (i >= 0) {
                textoEl.textContent = mensaje.slice(0, i);
                i--;
                whatsappCtaTimer = setTimeout(desteclear, velocidadBorrado);
            } else {
                whatsappCtaTimer = setTimeout(escribir, pausaInicio);
            }
        };
        desteclear();
    };

    textoEl.textContent = '';
    whatsappCtaTimer = setTimeout(escribir, 500);
}

function ocultarWhatsappCta() {
    const cta = document.getElementById('whatsapp-cta');
    if (cta) {
        cta.classList.remove('visible');
        cta.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('has-wa-cta');

    if (whatsappCtaTimer !== null) {
        clearTimeout(whatsappCtaTimer);
        whatsappCtaTimer = null;
    }
}

// --- Toast con estilo (reemplaza los alert nativos) ---
function mostrarToast(mensaje, duracion = 4000) {
    const cont = document.getElementById('toast-container');
    if (!cont) return;
    cont.textContent = mensaje;
    cont.classList.add('visible');
    if (toastTimer !== null) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => cont.classList.remove('visible'), duracion);
}

// --- Contador flotante de contenido (solo galería completa) ---
function actualizarContadorMedia(tipo) {
    const el = document.getElementById('media-counter');
    if (!el || !contadorHabilitado) return;

    let n = 0;
    let emoji = '🎥';
    if (tipo === 'videos') { n = conteoVideos; emoji = '🎥'; }
    else if (tipo === 'collages') { n = conteoCollages; emoji = '📸'; }
    else if (tipo === 'finales') { n = conteoFinales; emoji = '🎬'; }

    if (n > 0) {
        el.textContent = `${emoji} ${n}`;
        el.classList.add('visible');
        el.setAttribute('aria-hidden', 'false');
    } else {
        el.classList.remove('visible');
        el.setAttribute('aria-hidden', 'true');
    }
}

document.addEventListener("DOMContentLoaded", () => {
    ocultarLogoInicialmente();
    aplicarIdioma();

    // Mostrar/ocultar contraseña (icono de ojo)
    const passToggle = document.getElementById('password-toggle');
    const passInput = document.getElementById('password-input');
    if (passToggle && passInput) {
        passToggle.addEventListener('click', () => {
            const oculto = passInput.type === 'password';
            passInput.type = oculto ? 'text' : 'password';
            passToggle.classList.toggle('active', oculto);
        });
    }

    // Tema oscuro: re-evaluar si cambia el modo oscuro del sistema
    if (window.matchMedia) {
        try {
            window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
                document.documentElement.classList.toggle('tema-oscuro', e.matches);
            });
        } catch (e) { }
    }
});